var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOregon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.952,110.224l-3.336-7.579L223.04,98.61l-23.854-5.478l-24.319,0.185l-1.383-2.95l-6.734,3.41l-7.286,0.188 l-3.873-3.138l-2.308,0.829l-9.776-0.276l-14.85-6.917l-2.214,2.031h-9.039l-8.856-5.905l-1.474-18.077l-7.933-1.291l-1.289-3.875 l-2.708-1.015l-9.101,3.23c0,0-18.692,63.949-45.503,98.629l-2.459,21.4l3.69,7.379c0,0,126.548,36.771,168.486,45.012l13.28-59.525 l5.165-11.314l-1.475-3.443c0,0-3.446,1.475-4.184-0.984c-0.738-2.461,6.889-13.65,6.889-13.65l3.688-1.354l1.722-6.147 l14.021-16.727v-5.657L243.952,110.224z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOregon);
export default __webpack_public_path__ + "static/media/oregon.b1e0362370533e90aa8fb7e5501e2104.svg";
export { ForwardRef as ReactComponent };